import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

import { PermissionsEnum } from '../../../../api/api-reference';
import {
  Client,
  PageInfo,
  ServiceTypeDataIn,
  ServiceTypeDataOut,
  ServiceTypeGetAllDataIn,
  SortingType,
} from '../../../../api/api-reference';
import { AuthService } from '../../../../services/auth.service';
import { SearchComponent } from '../../../core/components/search/search.component';
import { SortComponent } from '../../../core/components/sort/sort.component';
import { PaginationComponent } from '../../../core/components/pagination/pagination.component';
import { ServiceTypeSetupComponent } from './service-type-setup/service-type-setup.component';
import { ConfirmDialogComponent } from '../../../core/components/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-service-type-management',
  standalone: true,
  imports: [
    ServiceTypeSetupComponent,
    SearchComponent,
    SortComponent,
    FormsModule,
    CommonModule,
    TranslateModule,
    PaginationComponent,
    ConfirmDialogComponent,
  ],
  templateUrl: './service-type-management.component.html',
  styleUrl: './service-type-management.component.scss',
})
export class ServiceTypeManagementComponent {
  data: ServiceTypeDataOut[] | undefined = [];
  public pageSize: number = 10;
  public pageNumber: number = 1;
  public lastPageSize: number = 1;
  public currentPage: number = 1;
  isModalOpen = false;
  isAddClicked = false;
  selectedRowId: string | null = null;
  public numberOfServiceTypes: number = 0;
  public PermissionsEnum = PermissionsEnum;

  requestData = new ServiceTypeGetAllDataIn({
    pageInfo: new PageInfo({ pageSize: this.pageSize, page: this.pageNumber }),
    search: undefined,
    sorting: SortingType.Descending,
  });

  constructor(
    private client: Client,
    private toastr: ToastrService,
    public authService: AuthService,
  ) {
    this.reloadTable(1);
  }

  toggleModal(reload?: boolean) {
    this.selectedRowId = null;
    this.isAddClicked = !this.isAddClicked;
    if (reload) {
      this.reloadTable();
    }
  }

  onSortOption(selectedSort?: SortingType) {
    if (selectedSort) this.requestData.sorting = selectedSort;
    this.reloadTable();
  }

  handleRowClick(row: ServiceTypeDataOut) {
    this.selectedRowId = row.id!;
    if (!this.isModalOpen) {
      this.isAddClicked = true;
    }
  }

  reloadTable(page?: number) {
    this.pageNumber = page || 0;
    if (page) this.requestData!.pageInfo!.page = this.pageNumber;

    this.client.serviceTypeQuery(this.requestData).subscribe({
      next: (response) => {
        this.data = response.data;
        this.numberOfServiceTypes = response.count || 0;
        this.lastPageSize = Math.ceil(
          this.numberOfServiceTypes / this.pageSize,
        );
      },
      error: (err) => {
        this.toastr.error(err);
      },
    });
    this.selectedRowId = null;
  }

  searchChange(searchText: string) {
    this.requestData.search = searchText;
    this.reloadTable(1);
  }

  handleDelete() {
    this.isModalOpen = true;
  }

  confirmDelete(row: string) {
    this.client.deleteServiceType(row).subscribe({
      next: (response) => {
        this.toastr.success(response);
        this.reloadTable(this.currentPage);
      },
      error: (err) => {
        this.toastr.error(err);
      },
    });
    this.isModalOpen = false;
    this.selectedRowId = null;
    this.isAddClicked = false;
  }

  cancelDelete() {
    this.isModalOpen = false;
    this.selectedRowId = null;
  }
  pageChange(value: number) {
    this.currentPage = value;
    this.reloadTable(this.currentPage);
  }
}
